module.exports = __webpack_public_path__ + "static/img/niksen.b5e72988.jpeg";